<template>
  <v-card
    class="mx-auto rounded-card card-shadow"
    v-bind="$attrs"
  >
    <v-card-text class="text--primary">
      <figure>
        <v-chart :options="chart"
                 ref="comprasCentroCustoChart"
                 theme="secondary"
                 autoresize/>
      </figure>
    </v-card-text>
  </v-card>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';
import { buildKeyValueChart, getColorFromDataIndex, toEchartData } from '@/utils/chart-utils';
import { colorPallete } from '@/plugins/echarts/echarts-colors';
import IndicadoresService from '../dashboard/dashboard-service';

export default {
  props: {
    stringFilter: String,
  },
  data() {
    return {
      compras: null,
      chart: null,
    };
  },
  mixins: [chartMixin],
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getCompras();
    },
  },
  methods: {
    showLoading() {
      this.$refs.comprasCentroCustoChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      if (!this.$refs.comprasCentroCustoChart) {
        return;
      }
      this.$refs.comprasCentroCustoChart.hideLoading();
    },
    buildChart() {
      const comprasPorCentroCusto = buildKeyValueChart(this.compras);
      return {
        title: {
          text: 'Compras por centro de custo',
        },
        tooltip: {
          formatter: this.tooltipFormatter,
        },
        dataset: {
          source: [
            ['Compras'],
            ...toEchartData(comprasPorCentroCusto, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
          splitNumber: 1,
          axisLabel: {
            formatter: this.axisFormatterTruncate(10),
          },
        },
        yAxis: {
          axisLabel: {
            formatter: this.axisMoneyFormatter,
          },
        },
        grid: {
          left: '15%',
        },
        series: [{
          type: 'bar',
          seriesLayoutBy: 'column',
          itemStyle: {
            color(param) {
              const { dataIndex } = param;
              return getColorFromDataIndex(dataIndex, colorPallete);
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        }],
      };
    },
    getCompras() {
      const filter = this.stringFilter;

      this.showLoading();
      IndicadoresService.getComprasPorCentroCusto({ filter })
        .then((response) => {
          this.compras = response.data;
          this.chart = this.buildChart();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  mounted() {
    this.getCompras();
  },
};
</script>
